import { AppBar, Box, Button, Container, Drawer, Grid, IconButton, Menu, MenuItem, Stack, Toolbar, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'
import logo from "../../Assets/logo.png"
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import MenuIcon from '@mui/icons-material/Menu';
import "../../styles/Navbar.css"
import { Cancel, ArrowDropDown } from '@mui/icons-material';
import urlEnd from '../endpoints/Endpoints';
import urlBase from '../url/urlBase';
import { googlePlay, appStore } from '../url/downloadUrl';
import LanguageSelector from '../common/LanguageSelector';

const drawerWidth = 280;

function Navbar() {
    const { t } = useTranslation(['common']);
    const [open, setOpen] = React.useState(false);
    const [downloadMenuAnchor, setDownloadMenuAnchor] = React.useState(null);
    const [mobileDownloadMenuAnchor, setMobileDownloadMenuAnchor] = React.useState(null);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleDownloadMenuOpen = (event) => {
        setDownloadMenuAnchor(event.currentTarget);
    };

    const handleDownloadMenuClose = () => {
        setDownloadMenuAnchor(null);
    };

    const handleMobileDownloadMenuOpen = (event) => {
        setMobileDownloadMenuAnchor(event.currentTarget);
    };

    const handleMobileDownloadMenuClose = () => {
        setMobileDownloadMenuAnchor(null);
    };

    return (
        <>
            <Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}>
                <AppBar position="fixed" sx={{ background: "#FFFFFF 0% 0% no-repeat padding-box", opacity: 1, boxShadow: "#00000029 0px 3px 6px" }} >
                    <Toolbar>
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item md={2.5} lg={2.5}>
                                    <NavLink to={`${urlEnd}`}><img src={logo} className="logo" alt={t("common:brand")} /></NavLink>
                                </Grid>

                                <Grid item md={5} lg={5} align="center">
                                    <Box>
                                        <Stack direction="row" spacing={{ md: 1, lg: 3 }} justifyContent="center" sx={{ color: "#252525", fontSize: "small", fontWeight: "bold", cursor: "pointer" }}>
                                            <ul className='navbar'>
                                                <li><NavLink to={`${urlEnd}`} className="navbar-link">{t("common:nav.home")}</NavLink></li>
                                                <li><NavLink to={`${urlEnd}about`} className="navbar-link">{t("common:nav.about")}</NavLink></li>
                                                <li><NavLink to={`${urlEnd}howitwork`} className="navbar-link">{t("common:nav.howItWorks")}</NavLink></li>
                                                <li><NavLink to={`${urlEnd}plans`} className="navbar-link">{t("common:nav.pricing")}</NavLink></li>
                                                <li><NavLink to={`${urlEnd}security`} className="navbar-link">{t("common:nav.security")}</NavLink></li>
                                                <li><NavLink to={`${urlEnd}contact`} className="navbar-link">{t("common:nav.contact")}</NavLink></li>
                                            </ul>
                                        </Stack>
                                    </Box>
                                </Grid>

                                <Grid item md={4.5} lg={4.5} align="right">
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
                                        <LanguageSelector />
                                        <a
                                            target='_blank'
                                            rel="noopener noreferrer"
                                            href={`${urlBase}`}
                                            style={{
                                                cursor: "pointer",
                                                textDecoration: "none",
                                                fontSize: "small",
                                            }}
                                            className='btn_login'
                                        >
                                            <span style={{
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                                color: "#FFFFFF",
                                            }}>{t("common:buttons.login")}</span>
                                        </a>
                                        <a
                                            target='_blank'
                                            rel="noopener noreferrer"
                                            href={`${urlBase}signup`}
                                            style={{
                                                cursor: "pointer",
                                                textDecoration: "none",
                                                fontSize: "small",
                                            }}
                                            className='btn_login'
                                        >
                                            <span style={{
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                                color: "#FFFFFF",
                                            }}>{t("common:buttons.signupNow")}</span>
                                        </a>
                                        <Box
                                            onClick={handleDownloadMenuOpen}
                                            className='btn_login'
                                            sx={{
                                                cursor: "pointer",
                                                textDecoration: "none",
                                                fontSize: "small",
                                                backgroundColor: "#1eade8"
                                            }}
                                        >
                                            <span style={{
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                                color: "#FFFFFF",
                                            }}>{t("common:buttons.getApp")}</span>
                                        </Box>
                                        <Menu
                                            anchorEl={downloadMenuAnchor}
                                            open={Boolean(downloadMenuAnchor)}
                                            onClose={handleDownloadMenuClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <MenuItem 
                                                onClick={handleDownloadMenuClose}
                                                component="a"
                                                href={appStore}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t("common:buttons.iosDownload")}
                                            </MenuItem>
                                            <MenuItem 
                                                onClick={handleDownloadMenuClose}
                                                component="a"
                                                href={googlePlay}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t("common:buttons.androidDownload")}
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </Toolbar>
                </AppBar>
            </Box>

            {/* responsive */}
            <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
                <AppBar sx={{ backgroundColor: "white" }}>
                    <Toolbar>
                        <Grid container spacing={2} pt={1} alignItems="center">
                            <Grid item xs={6} sm={6}>
                                <NavLink to={`${urlEnd}`}><img src={logo} alt={t("common:brand")} style={{ width: "25vh" }} /></NavLink>
                            </Grid>
                            <Grid item xs={6} sm={6} align="right" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
                                <LanguageSelector isMobile />
                                <IconButton
                                    color="inherit"
                                    aria-label={t("common:buttons.openMenu")}
                                    onClick={handleDrawerOpen}>
                                    <MenuIcon sx={{ color: "#252525" }} />
                                </IconButton>
                                <Drawer
                                    sx={{
                                        width: "100%",
                                        flexShrink: 0,
                                        "& .MuiDrawer-paper": {
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }
                                    }}
                                    anchor="right"
                                    open={open}
                                    onClose={handleDrawerClose}
                                >
                                    <Stack direction="column" spacing={0} sx={{ color: "#252525", marginTop: "4vh", fontWeight: "bold", cursor: "pointer" }}>
                                        <Grid container spacing={0} alignItems="center">
                                            <Grid xs={2} align="left" pl={2}>
                                                <IconButton 
                                                    onClick={handleDrawerClose}
                                                    aria-label={t("common:buttons.closeMenu")}
                                                    sx={{ 
                                                        color: "gray",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(0, 0, 0, 0.04)"
                                                        }
                                                    }}
                                                >
                                                    <Cancel fontSize="large" />
                                                </IconButton>
                                            </Grid>

                                            <Grid xs={10} align="center">
                                                <NavLink to={`${urlEnd}`}><img src={logo} alt={t("common:brand")} style={{ width: "55%", alignSelf: "center" }} /></NavLink>
                                            </Grid>
                                        </Grid>

                                        <Box ml={-3} mt={2}>
                                            <ul className='navbar_responsive'>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}`} className="navbar-link">{t("common:nav.home")}</NavLink></li>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}about`} className="navbar-link">{t("common:nav.about")}</NavLink></li>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}howitwork`} className="navbar-link">{t("common:nav.howItWorks")}</NavLink></li>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}plans`} className="navbar-link">{t("common:nav.pricing")}</NavLink></li>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}security`} className="navbar-link">{t("common:nav.security")}</NavLink></li>
                                                <li onClick={handleDrawerClose}><NavLink to={`${urlEnd}contact`} className="navbar-link">{t("common:nav.contact")}</NavLink></li>
                                            </ul>
                                        </Box>

                                        <Box ml={2} mr={2} mt={2} mb={2}>
                                            <Stack direction="column" spacing={1.5} alignItems="flex-start">
                                                <a
                                                    target='_blank'
                                                    rel="noopener noreferrer"
                                                    href={`${urlBase}`}
                                                    onClick={handleDrawerClose}
                                                    style={{
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                        fontSize: "14px",
                                                        display: "inline-block",
                                                        width: "fit-content",
                                                        minWidth: "120px",
                                                        textAlign: "center",
                                                        backgroundColor: "#00DCBC",
                                                        border: "none",
                                                        padding: "10px 20px",
                                                        borderRadius: "50px",
                                                        color: "white"
                                                    }}
                                                >
                                                    {t("common:buttons.login")}
                                                </a>
                                                <a
                                                    target='_blank'
                                                    rel="noopener noreferrer"
                                                    href={`${urlBase}signup`}
                                                    onClick={handleDrawerClose}
                                                    style={{
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                        fontSize: "14px",
                                                        display: "inline-block",
                                                        width: "fit-content",
                                                        minWidth: "120px",
                                                        textAlign: "center",
                                                        backgroundColor: "#00DCBC",
                                                        border: "none",
                                                        padding: "10px 20px",
                                                        borderRadius: "50px",
                                                        color: "white"
                                                    }}
                                                >
                                                    {t("common:buttons.signupNow")}
                                                </a>
                                                <Box
                                                    onClick={handleMobileDownloadMenuOpen}
                                                    sx={{
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        display: "inline-block",
                                                        width: "fit-content",
                                                        minWidth: "120px",
                                                        textAlign: "center",
                                                        backgroundColor: "#1eade8",
                                                        border: "none",
                                                        padding: "10px 20px",
                                                        borderRadius: "50px",
                                                        color: "white"
                                                    }}
                                                >
                                                    {t("common:buttons.getApp")}
                                                </Box>
                                                <Menu
                                                    anchorEl={mobileDownloadMenuAnchor}
                                                    open={Boolean(mobileDownloadMenuAnchor)}
                                                    onClose={handleMobileDownloadMenuClose}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'left',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left',
                                                    }}
                                                >
                                                    <MenuItem 
                                                        onClick={() => {
                                                            handleMobileDownloadMenuClose();
                                                            handleDrawerClose();
                                                        }}
                                                        component="a"
                                                        href={appStore}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {t("common:buttons.iosDownload")}
                                                    </MenuItem>
                                                    <MenuItem 
                                                        onClick={() => {
                                                            handleMobileDownloadMenuClose();
                                                            handleDrawerClose();
                                                        }}
                                                        component="a"
                                                        href={googlePlay}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {t("common:buttons.androidDownload")}
                                                    </MenuItem>
                                                </Menu>
                                            </Stack>
                                        </Box>

                                    </Stack>

                                    <div className='container'>
                                        <div className='content'>
                                            <Grid xs={12} align="center">
                                                <Box p={3} align="center">
                                                    <Typography variant="paragraph" fontWeight="bold" fontSize="15px" color="#02B096">
                                                        {t("common:footer.allRightsReserved", { year: new Date().getFullYear() })}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </div>
                                    </div>
                                </Drawer>
                            </Grid>
                        </Grid>

                    </Toolbar>

                </AppBar>

            </Box>
        </>
    )
}

export default Navbar
